'use client';
import { ServerErrorContainer } from './_components/Errors/ServerErrorContainer';

export default function Error({
    error,
    reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
    return <ServerErrorContainer error={error} reset={reset} />;
}
